<template>
    <section id="all_transactions" class="all_transactions">
        <div class="top_section">
            <h1 class="font-apercu-bold is-size-4">{{ $t("Transactions") }}</h1>
        </div>
        <div id="main-card">
            <div class="card-head">
                <div class="l-sec">
                    <div style="margin: 0 45px">
                        <div class="balance is-size-4">
                            <img src="../assets/images/logo.png" alt />

                            <span style="color: #12d684">{{
                                userData.balance | currency("")
                            }}</span>
                            <span class="font-10" style="color: #000">{{
                                $t("SAR")
                            }}</span>
                        </div>
                        <div class="balance is-size-4">
                            <span
                                style="
                                    color: #444;
                                    font-size: 14px;
                                    font-weight: lighter !important;
                                "
                                >{{ $t("Invoiced amount") }}</span
                            >

                            <span style="margin: 5px; color: #4952ff">{{
                                statistics.due_invoiced_amount | currency("")
                            }}</span>
                            <span class="font-10" style="color: #000">{{
                                $t("SAR")
                            }}</span>
                        </div>
                        <div class="balance is-size-4">
                            <span
                                style="
                                    color: #444;
                                    font-size: 14px;
                                    font-weight: lighter !important;
                                "
                                >{{ $t("Un-invoiced amount") }}</span
                            >

                            <span style="margin: 5px; color: #ff7977">{{
                                statistics.non_invoiced_orders_amount
                                    | currency("")
                            }}</span>
                            <span class="font-10" style="color: #000">{{
                                $t("SAR")
                            }}</span>
                        </div>
                    </div>
                    <div
                        style="
                            width: 100%;
                            display: flex;
                            justify-content: center;
                        "
                    >
                        <input
                            type="text"
                            v-model="search"
                            :placeholder="
                                $t(
                                    'Search with Transaction Id or Shipment tracking'
                                )
                            "
                        />
                    </div>
                </div>
                <div class="r-sec">
                    <export-excel
                        :title="$t('ALKOON Transactions')"
                        class
                        :fields="json_fields"
                        :data="transactions"
                        :before-finish="resetIndex"
                        worksheet="ALKOON Transactions"
                        name="ALKOON_Transactions.xls"
                    >
                        <button class="button">{{ $t("Export") }}</button>
                    </export-excel>
                </div>
            </div>
            <div class="table">
                <b-table
                    :loading="loading"
                    :data="filterdTransaction"
                    :paginated="isPaginated"
                    :per-page="perPage"
                    :current-page.sync="currentPage"
                    :pagination-simple="isPaginationSimple"
                    :pagination-position="paginationPosition"
                    :default-sort-direction="defaultSortDirection"
                    :sort-icon="sortIcon"
                    :sort-icon-size="sortIconSize"
                    :aria-next-label="$t('Next page')"
                    :aria-previous-label="$t('Previous page')"
                    :aria-page-label="$t('Page')"
                    :aria-current-label="$t('Current page')"
                >
                    <template slot-scope="props">
                        <b-table-column
                            field="id"
                            :label="$t('Transaction ID')"
                            sortable
                            width="200"
                            >{{ props.row.id }}</b-table-column
                        >

                        <b-table-column
                            field="date"
                            :label="$t('Date')"
                            sortable
                            :centered="false"
                            width="200"
                        >
                            {{ props.row.date | moment("DD MMM YYYY") }}
                        </b-table-column>

                        <b-table-column
                            :class="[
                                props.row.credit - props.row.debit > 1
                                    ? 'primary'
                                    : 'danger',
                            ]"
                            field="credit"
                            :label="$t('Amount')"
                            sortable
                            :centered="false"
                            width="200"
                        >
                            {{
                                (props.row.credit - props.row.debit)
                                    | currency("")
                            }}
                            SAR
                        </b-table-column>

                        <b-table-column
                            field="order_id"
                            :label="$t('Shipment tracking')"
                            sortable
                            :centered="false"
                            width="250"
                            >{{ props.row.order_id }}</b-table-column
                        >
                        <b-table-column
                            field="description"
                            :label="$t('Description')"
                            :centered="false"
                            sortable
                            >{{ props.row.description }}</b-table-column
                        >
                    </template>
                </b-table>
            </div>
        </div>
    </section>
</template>

<script>
import moment from "moment";
export default {
    data() {
        return {
            isPaginated: true,
            isPaginationSimple: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
            filterdTransaction: [],
            search: "",
            loading: true,
            current_index: 0,
            json_fields: {
                [this.$t("Transaction ID")]: "id",
                [this.$t("Date")]: {
                    field: "date",
                    callback: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                [this.$t("Amount") + " " + this.$t("SAR")]: {
                    field: "debit",
                    callback: (value) => {
                        let data =
                            this.transactions[this.current_index].credit -
                            value;
                        this.current_index++;
                        return data.toFixed(2);
                    },
                },
                [this.$t("Shipment tracking")]: "order_id",
                [this.$t("Description")]: "description",
            },
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf-8",
                    },
                ],
            ],
        };
    },
    methods: {
        resetIndex() {
            this.current_index = 0;
        },
    },
    watch: {
        search: {
            immediate: true,
            handler(val) {
                if (val) {
                    let query = new RegExp(val, "i");
                    this.filterdTransaction = this.transactions.filter((t) =>
                        query.test(`${t.id} ${t.order_id}`)
                    );
                } else {
                    this.filterdTransaction = this.transactions;
                }
            },
        },
        transactions: {
            immediate: true,
            handler(val) {
                if (val.length) {
                    this.loading = false;
                    this.filterdTransaction = this.transactions;
                }
            },
        },
    },
    computed: {
        userData() {
            return this.$store.getters.userData;
        },
        transactions() {
            return this.$store.getters.getTransactions;
        },
        statistics() {
            return this.$store.getters.getStatistics;
        },
    },
    mounted() {
        this.$store.dispatch("GET_STATISTICS");
        this.$store.dispatch("GET_TRANSACTIONS");
    },
};
</script>

<style lang="scss">
#all_transactions {
    .top_section {
        margin-top: 20px;
        margin-bottom: 60px;
        display: flex;
        justify-content: space-between;

        .baredex-credit {
            background-color: #4952ff;
            color: white;
            width: 325px;
            height: 200px;
            border-radius: 15px;
            padding: 25px 15px;
            display: inline-block;

            .credits {
                font-weight: bold;
                color: white;
                font-size: 2.4rem;
            }
        }
    }

    .card-head {
        display: flex;
        padding-top: 30px;

        div {
            display: flex;
            align-items: flex-end;

            &.l-sec {
                width: 85%;
                flex-wrap: wrap;
                justify-content: flex-start;

                input {
                    background: #f7f7f7;
                    width: 90%;
                    padding: 16px 50px;
                    border-radius: 50px;
                    outline: none;
                    font-size: 18px;
                    font-weight: bold;
                    color: #444;
                    letter-spacing: 0.7px;

                    &::placeholder {
                        color: #444;
                        font-size: 14px;
                        font-weight: lighter !important;
                    }
                }

                .balance {
                    background: #f2f2f2;
                    padding: 5px 20px;
                    margin: 10px;
                    align-items: center;
                    display: flex;
                    height: 50px;

                    img {
                        width: 70px;
                    }

                    span {
                        font-size: 20px;
                    }
                }
            }

            &.r-sec {
                width: 30%;

                button {
                    margin: 10px;
                    height: 30px;
                    width: 130px;
                    border-radius: 7px;
                    padding: 0;
                }
            }
        }
    }
}

.table {
    margin-top: 40px;
    padding: 0 30px;

    table {
        width: 100%;

        thead {
            background: #f7f7f7;
            border-radius: 5px;
        }

        th {
            padding-top: 11px;
            padding-bottom: 11px;
        }

        tbody {
            tr {
                border-bottom: 1px solid #ddd;
                height: 60px;

                td {
                    vertical-align: middle;
                }
            }
        }

        .total {
            font-weight: bold;
            text-align: center;
        }

        .primary {
            color: #4952ff;
            font-weight: bold;
        }

        .danger {
            color: #ff7977;
            font-weight: bold;
        }

        .text-center {
            text-align: center;
        }
    }
}

td {
    border-bottom: 2px solid #f7f8fa !important;
    vertical-align: middle;
}

::v-deep {
    .is-centered {
        text-align: left !important;
    }

    .table {
        margin-top: 40px;
        padding: 0 30px;

        table {
            width: 100%;

            thead {
                background: #f7f7f7;
                border-radius: 5px;
            }

            th {
                padding-top: 11px;
                padding-bottom: 11px;
            }

            tbody {
                tr {
                    border-bottom: 1px solid #ddd;
                    height: 60px;
                    // &:last-of-type {
                    //     border: none;
                    // }
                }
            }

            .total {
                font-weight: bold;
                text-align: center;
            }

            .primary {
                color: #4952ff;
                font-weight: bold;
            }

            .danger {
                color: #ff7977;
                font-weight: bold;
            }

            .text-center {
                text-align: center;
            }
        }
    }
}
</style>
